import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { Device } from '../../classess/device/device';

import { GlobalFormats } from '../../classess/main/globalFormats';

import DeviceAddEditDetails from './DeviceAddEditDetails';
import {
    awaitDelayAsync, getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse, settings, styles,
    LoadingSection, handleResponseMessageAsync
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { DeviceService } from '../../services/devices/DeviceService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'Devices';

export default function Devices({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtDevicesId = 'dtDevices';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        addDevice: false,
        edit: false,
        delete: false,
    });
    const isMount = useRef(true);
    const [device, setDevice] = useState(Device?.getClass({}, false));
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageId: languageObj?.id,
        dtDevicesId: dtDevicesId,
        dtDevicesRowId: 0,
    });
    const controls = {
        buttons: {
            addDevice: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddCompany',
            },
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
        },
        dataTables: {
            devices: {
                inputs: {
                    search: {
                        id: `${dtDevicesId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtDevicesId}_length select`,
                        defaultClass: '',
                    },
                },
            },
        },
        icons: {
            addDevice: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        spiners: {
            addDevice: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region device
    const getAddDevice = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getAddDevice';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, addDevice: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            setDevice(Device?.getClass({}, false));

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 0,
                auth: auth,
                showModal: true,
            }));

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, addDevice: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getEditDevice = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getEditDevice';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let deviceData = Device?.getClass({}, false);
            //#endregion variables

            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, edit: true }));

            //#region device (get byid)
            response = await DeviceService.getById({
                auth,
                id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            deviceData = !isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: response?.result?.device, subMethod: currentMethod })?.result &&
                !isUndNull({ data: response?.result?.device?.id, subMethod: currentMethod })?.result &&
                response?.result?.device?.id > 0 ?
                Device?.getClass(response?.result.device, false) :
                {};
            //#endregion device (get byid)

            //#region check data
            if (isUndNullEmp({ data: deviceData, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>`;
                return;
            }
            //#endregion check data

            setDevice(Device?.getClass(deviceData, false));

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 1,
                auth: auth,
                showModal: true,
                dtDevicesRowId: rowId,
            }));

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, edit: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteDevice = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'deleteDevice';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.device[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: settings.colors.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings.colors.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data(device)
                        preConfirmResponse = await DeviceService.deleteAsync({
                            auth,
                            id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (device)

                        //#region delete datatable (device)
                        $(`#${dtDevicesId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                        //#endregion delete datatable (device)

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText: messages?.processCompletedSuccessfully?.[languageObj?.id]
                        });
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        preConfirmResponse.msgText += `Sub method: preConfirm<br/>`;
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire(swalProperties);
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, delete: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion device

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let devices = [];
            //#endregion variables

            setProcess(prev => ({ ...prev, showLoading: true }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (device)
                response = await DeviceService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                devices = response?.result.devices || [];
                //#endregion get data (device)

                //#region set datatable
                if (!isUndNullEmp({ data: devices, subMethod: currentMethod })?.result &&
                    devices.length > 0) {
                    response = setDataInDataTable({ data: devices, subMethod: currentMethod, });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtDevicesId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.name?.[languageObj?.id], width: '95%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtDevicesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtDevicesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtDevicesId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getEditDevice({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            break;
                        case 'delete':
                            deleteDevice({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let deviceDt = [];
            //#endregion variables

            //#region process
            data.forEach((device) => {
                const modelDevice = Device?.getClass(device, false);
                const processButtons = [];
                deviceDt.push([
                    modelDevice.name,
                    getProcessButtons({
                        id: modelDevice.id,
                        description: modelDevice.name,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtDevicesId}`)?.DataTable()?.rows?.add(deviceDt)?.draw(true);

            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.settings?.settings} process={app?.views?.devices?.devices} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.devices?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.devices?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.devices?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.devices} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.devices?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.tabletAlt} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addDevice?.id}
                                                            type='button'
                                                            className={process?.addDevice ? `${controls?.buttons?.addDevice?.defaultClass} ${settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addDevice?.defaultClass}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            disabled={process?.addDevice}
                                                            onClick={(e) => getAddDevice({ e: e, subMethod: controls?.buttons?.addDevice?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.addDevice ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addDevice?.id} className={controls?.icons?.addDevice?.defaultClass} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtDevicesId} languageObj={languageObj} />
                                            </div>
                                        </div>

                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <DeviceAddEditDetails modalObj={modalObj}
                    setModalObj={setModalObj}
                    device={device}
                    setDevice={setDevice}
                    getData={getData} />
            )}

        </div>
    );
}